import Select from "react-select";
import PropTypes from "prop-types";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useDispatch } from "react-redux";
import {
  getDesignationList,
  getUserList,
  addEditCommittee,
  getOneCommittee,
} from "../../Redux/Slices/committeeSlice";
import { getOneUserAnalytics } from "../../Redux/Slices/userAnalyticsSlice";

const AddEditCommittee = ({ isOpen, onClose, rowData }) => {
  const dispatch = useDispatch();
  const [designations, setDesignations] = useState([]);
  const [users, setUsers] = useState([]);
  const [allData, setAllData] = useState([]);
  const [memberSearch, setMemberSearch] = useState("");
  const [designationSearch, setDesignationSearch] = useState("");
  const [isUserLoading, setIsUserLoading] = useState(false);
  const [selectedDistrictId, setSelectedDistrictId] = useState("");
  const [selectedTalukaId, setSelectedTalukaId] = useState("");
  const [selectedDistrictName, setSelectedDistrictName] = useState("");
  const [selectedTalukaName, setSelectedTalukaName] = useState("");
  const [selectedVillageName, setSelectedVillageName] = useState("");
  const [isDesignationLoading, setIsDesignationLoading] = useState(false);

  const menuPortalStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
  };

  const initialValues = {
    committeeMemberId: "",
    user: "",
    designation: "",
    village: "",
    taluka: "",
    district: "",
  };
  const [formikInitialValue, setFormikInitialValue] = useState(initialValues);

  const validationSchema = Yup.object({
    // memberName: Yup.string().required("Member name is required"),
    // designation: Yup.string().required("Designation is required"),
    // village: Yup.string().required("Village is required"),
    // taluka: Yup.string().required("Taluka is required"),
    // district: Yup.string().required("District is required"),
  });

  const fetchUserData = async () => {
    if (rowData?._id) {
      const payload = { committeeMemberId: rowData?._id };
      try {
        const res = await dispatch(getOneCommittee(payload)).unwrap();
        if (res.IsSuccess) {
          setAllData(res?.Data);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    }
  };

  const getUser = async (search = "") => {
    setIsUserLoading(true);
    try {
      const payload = {
        search: search,
      };
      const response = await dispatch(getUserList(payload)).unwrap();
      if (response.IsSuccess) {
        setUsers(response.Data || []);
      }
    } catch (error) {
      toast.error("Failed to fetch Users");
    } finally {
      setIsUserLoading(false);
    }
  };
  const getDesignation = async (search = "") => {
    setIsDesignationLoading(true);
    try {
      const response = await dispatch(getDesignationList({ search })).unwrap();
      if (response.IsSuccess) {
        setDesignations(response.Data || []);
      }
    } catch (error) {
      toast.error("Failed to fetch Designation");
    } finally {
      setIsDesignationLoading(false);
    }
  };
  const getDistrict = () => { };
  const getTaluka = () => { };
  const getVillage = () => { };

  useEffect(() => {
    if (allData) {
      setFormikInitialValue({
        committeeMemberId: allData?._id || "",
        user: allData?.user?._id || "",
        designation: allData?.designation?._id || "",
        district: allData?.district?._id || "",
        taluka: allData?.taluka?._id || "",
        village: allData?.village?._id || "",
      });
      // Set local IDs and names for side effects and display
      setSelectedDistrictId(allData?.district?._id || "");
      setSelectedTalukaId(allData?.taluka?._id || "");
      setSelectedDistrictName(allData?.district?.gujarati_name || "");
      setSelectedTalukaName(allData?.taluka?.gujarati_name || "");
      setSelectedVillageName(allData?.village?.gujarati_name || "");
    } else {
      setFormikInitialValue(initialValues);
    }
  }, [allData]);

  useEffect(() => {
    // if (rowData) {
    //     setFormikInitialValue({
    //         committeeMemberId: rowData?._id || "",
    //         user: rowData?.user?._id || "",
    //         designation: rowData?.designation?._id || "",
    //         district: rowData?.district?._id || "",
    //         taluka: rowData?.taluka?._id || "",
    //         village: rowData?.village?._id || "",
    //     });
    //     // Load related talukas and villages
    //     if (rowData?.district?._id) {
    //         getTaluka(rowData.district._id);
    fetchUserData();
    getDesignation();
  }, [rowData]);

  useEffect(() => {
    getUser(memberSearch);
  }, [memberSearch]);

  useEffect(() => {
    getDesignation(designationSearch);
  }, [designationSearch]);

  const handleSubmit = async (values) => {
    const payload = {
      ...values,
      committeeMemberId: values?.committeeMemberId || "",
      user: values?.user || "",
      designation: values?.designation || "",
      district: values?.district || "",
      taluka: values?.taluka || "",
      village: values?.village || "",
    };
    const response = await dispatch(addEditCommittee(payload)).unwrap();
    if (response.IsSuccess) {
      toast.success(response.Message);
    }
    onClose();
  };

  if (!isOpen) return null;
  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      <div className="fixed inset-0 bg-black opacity-50 backdrop-blur-lg overflow-hidden"></div>
      <div className="flex items-center justify-center min-h-screen p-4">
        <div className="relative bg-white rounded-3xl shadow-xl max-w-4xl w-full p-3 md:p-7">
          <div className="flex items-center justify-between p-2 md:p-4">
            <h3 className="text-24 lg:text-36 font-bold text-text_1">
              Add Committee Member
            </h3>
            <button onClick={onClose} className="text-text_1">
              <svg
                className="w-6 h-6"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
          </div>

          <Formik
            initialValues={formikInitialValue}
            validationSchema={validationSchema}
            onSubmit={handleSubmit}
            enableReinitialize={true}
          >
            {({ isSubmitting, setFieldValue, values }) => (
              <>
                <div className="lg:p-4 p-2.5">
                  <Form className="space-y-2 md:space-y-4">
                    <div className="flex flex-wrap -mx-3">
                      <div className="w-full md:w-1/2 px-3 py-3">
                        <label
                          htmlFor="user"
                          className="block text-14 md:text-16 font-bold text-text_2 mb-1"
                        >
                          Member Name
                        </label>
                        <Select
                          id="user"
                          name="user"
                          isLoading={isUserLoading}
                          filterOption={() => true}
                          inputValue={memberSearch}
                          onInputChange={(inputValue, { action }) => {
                            if (action === "input-change") setMemberSearch(inputValue);
                          }}
                          onBlur={() => setMemberSearch("")}
                          options={users.map((item) => ({
                            value: item?._id,
                            label:
                              item?.surname +
                              " " +
                              item?.name +
                              " " +
                              item?.fathername +
                              ` (${item?.village?.gujarati_name || ""})`,
                          }))}
                          value={
                            users
                              .filter((u) => u._id === values.user)
                              .map((item) => ({
                                value: item?._id,
                                label:
                                  item?.surname +
                                  " " +
                                  item?.name +
                                  " " +
                                  item?.fathername +
                                  ` (${item?.village?.gujarati_name || ""})`,
                              }))[0] || null
                          }
                          onChange={async (selectedOption) => {
                            setMemberSearch("");
                            const userId = selectedOption
                              ? selectedOption.value
                              : "";
                            setFieldValue("user", userId);

                            if (userId) {
                              try {
                                const payload = { userId };
                                const res = await dispatch(
                                  getOneUserAnalytics(payload),
                                ).unwrap();
                                if (res.IsSuccess && res.Data) {
                                  setFieldValue("district", res.Data.district?._id || "");
                                  setFieldValue("taluka", res.Data.taluka?._id || "");
                                  setFieldValue("village", res.Data.village?._id || "");

                                  setSelectedDistrictName(res.Data.district?.gujarati_name || "");
                                  setSelectedTalukaName(res.Data.taluka?.gujarati_name || "");
                                  setSelectedVillageName(res.Data.village?.gujarati_name || "");

                                  setSelectedDistrictId(res.Data.district?._id || "");
                                  setSelectedTalukaId(res.Data.taluka?._id || "");
                                }
                              } catch (error) {
                                toast.error("Failed to fetch user details");
                              }
                            }
                          }}
                          placeholder="Select Member"
                          classNamePrefix="react-select"
                          menuPortalTarget={document.body}
                          styles={menuPortalStyles}
                          isClearable
                        />
                      </div>
                      <div className="w-full md:w-1/2 px-3 py-3">
                        <label
                          htmlFor="designation"
                          className="block text-14 md:text-16 font-bold text-text_2 mb-1"
                        >
                          Designation
                        </label>
                        <Select
                          id="designation"
                          name="designation"
                          isLoading={isDesignationLoading}
                          filterOption={() => true}
                          inputValue={designationSearch}
                          onInputChange={(inputValue, { action }) => {
                            if (action === "input-change") setDesignationSearch(inputValue);
                          }}
                          onBlur={() => setDesignationSearch("")}
                          options={designations.map((item) => ({
                            value: item?._id,
                            label: item?.gujarati_name,
                          }))}
                          value={
                            designations
                              .filter((d) => d._id === values.designation)
                              .map((item) => ({
                                value: item?._id,
                                label: item?.gujarati_name,
                              }))[0] || null
                          }
                          onChange={(selectedOption) => {
                            setDesignationSearch("");
                            setFieldValue(
                              "designation",
                              selectedOption ? selectedOption.value : "",
                            );
                          }}
                          placeholder="Select Designation"
                          classNamePrefix="react-select"
                          menuPortalTarget={document.body}
                          styles={menuPortalStyles}
                          isClearable
                        />
                      </div>
                      <div className="w-full flex flex-wrap -mx-3">
                        <div className="w-full md:w-1/3 px-3 py-3">
                          <label className="block text-14 md:text-16 font-bold text-text_2 mb-1">
                            District Name
                          </label>
                          <input
                            type="text"
                            value={selectedDistrictName}
                            className="w-full px-3 py-2 bg-[#EEEEEE] rounded-md focus:outline-none"
                            readOnly
                            placeholder="District"
                          />
                        </div>
                        <div className="w-full md:w-1/3 px-3 py-3">
                          <label className="block text-14 md:text-16 font-bold text-text_2 mb-1">
                            Taluka Name
                          </label>
                          <input
                            type="text"
                            value={selectedTalukaName}
                            className="w-full px-3 py-2 bg-[#EEEEEE] rounded-md focus:outline-none"
                            readOnly
                            placeholder="Taluka"
                          />
                        </div>
                        <div className="w-full md:w-1/3 px-3 py-3">
                          <label className="block text-14 md:text-16 font-bold text-text_2 mb-1">
                            Village Name
                          </label>
                          <input
                            type="text"
                            value={selectedVillageName}
                            className="w-full px-3 py-2 bg-[#EEEEEE] rounded-md focus:outline-none"
                            readOnly
                            placeholder="Village"
                          />
                        </div>
                      </div>
                    </div>
                    <div className="flex items-center justify-center p-4 space-x-3 xl:space-x-5">
                      <button
                        type="button"
                        onClick={onClose}
                        className="btn_secondary"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        disabled={isSubmitting}
                        className="btn py-2.5 md:py-3.5 px-8 md:px-12"
                      >
                        {isSubmitting ? "Submitting..." : "Save"}
                      </button>
                    </div>
                  </Form>
                </div>
              </>
            )}
          </Formik>
        </div>
      </div>
    </div>
  );
};

AddEditCommittee.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  rowData: PropTypes.object,
  getTalukaListFun: PropTypes.func,
  children: PropTypes.any,
};

export default AddEditCommittee;
